import { get } from './api';
import {
  GetGroupedReleaseNotesResponseDTO,
  LatestReleaseNoteDto,
} from 'declarations/dto/releaseNotes';

export const getGroupedReleaseNotesApi = async () => {
  const response = await get<GetGroupedReleaseNotesResponseDTO>(`/release-notes/grouped`);

  return response.data;
};

export const getLatestReleaseNoteApi = async () => {
  const response = await get<LatestReleaseNoteDto>(`/release-notes/latest`);

  return response.data;
};
